import React, { useEffect, useContext } from "react";
import styled, { keyframes } from "styled-components";
import Web3 from "web3";

import { CONTRACT_ADDRESS, HOST, NODE_ENDPOINT } from "../../Utils/constants";
import languagePack from "../../Utils/language";
import useState from "../../Hooks/useState";
import globalContext from "../../Hooks/globalContext";
import TokenRow from "../../Components/Main/TokenRow";
import MyWalletInfo from "../../Components/Main/MyWalletInfo";
import PageWrapper from "../../Components/Common/PageWrapper";
import Axios from "axios";

const web3 = new Web3(
  new Web3.providers.HttpProvider(NODE_ENDPOINT, {
    headers: [],
  })
);

const Content = styled.div`
  width: 100%;
  padding: 15px;
`;

const Page = ({ history, page }) => {
  const { getBalance, contract, user, balance, toggleMain, httpHeader } = useContext(globalContext);

  const getMarketcap = async () => {
    // const { data } = await Axios.post(`${HOST}/api/marketcap`, null, httpHeader());
    // marketcap.setState(data);
  };

  const preload = () => {
    if (user.state && contract.state && !toggleMain.state) {
      toggleMain.setState(true);
      getBalance();
    }
  };
  const marketcapPreload = () => {
    getMarketcap();
  };

  useEffect(() => {
    marketcapPreload();
  }, []);

  useEffect(preload, [user.state, contract.state]);
  return (
    <PageWrapper>
      {user.state && <MyWalletInfo />}
      <Content>
        <TokenRow balance={balance.state.lcms} symbol={"lcms"} fullName={"Lcm Science"} />
        <TokenRow balance={balance.state.esg} symbol={"esg"} fullName={"Energy Solution Global"} />
        <TokenRow balance={balance.state.eth} symbol={"eth"} fullName={"Ethereum"} />
        <TokenRow balance={balance.state.usdt} symbol={"usdt"} fullName={"Tether USD"} />
      </Content>
    </PageWrapper>
  );
};

export default Page;
